<script setup lang="ts">
import outfitWoff2 from '~/assets/fonts/Outfit-VariableFont_wght.woff2?url'

const appStore = useAppStore()
const route = useRoute()

useHead({
  link: [{ rel: 'preload', href: outfitWoff2, as: 'font', type: 'font/woff2', crossorigin: '' }],
})

const props = withDefaults(
  defineProps<{
    forceDefaultTopNav?: boolean
  }>(),
  {
    forceDefaultTopNav: false,
  },
)
const isHomePage = computed(() => route.meta.title === 'home')
// 允许自带头部的页面复用默认尾部，同时避免重复渲染公共头部。
const shouldShowDefaultTopNav = computed(() => props.forceDefaultTopNav || route.meta.hideDefaultTopNav !== true)

const isFeedbackDetailPage = computed(() => route.path.includes('/feedback/detail/'))
/**
 * 根据不同页面路由计算自定义背景颜色，方便后续扩展
 */
const customBgColor = computed(() => {
  if (isFeedbackDetailPage.value) {
    return '#FFF'
  }
  return ''
})
</script>

<template>
  <div class="wiki-bit-pc">
    <CommonRiskModuleFxeye />
    <HeaderWikiBitPcTopNav
      v-if="shouldShowDefaultTopNav"
      :always-expand-search="!isHomePage"
      :force-solid-background="false"
    />
    <slot />
    <LazyVisibleFooterWikiBitPcBootomMap
      :hydrate-on-visible="{ rootMargin: `${appStore.hydrateOnVisibleRootMargin}px 0px` }"
    />
  </div>
</template>

<style lang="less">
@media screen and (min-width: 799px) {
  html,
  body {
    font-family: 'Outfit';
  }
}

@media screen and (max-width: 799px) {
  html {
    overflow-x: auto;
  }

  .wiki-bit-pc.wiki-bit-pc--news-detail {
    min-width: 800px;
  }
}

@media screen and (min-width: 800px) and (max-width: 1199px) {
  .wiki-bit-pc.wiki-bit-pc--responsive-grid {
    min-width: 800px;
  }
}

@media screen and (max-width: 799px) {
  .wiki-bit-pc.wiki-bit-pc--responsive-grid {
    min-width: 800px;
  }
}
</style>
